export default __webpack_public_path__ + "content/8dc1cedf1f4987f82b7284beb2cd23fa.woff2";